import F1Theme from "../F1-theme";
import LincolnTheme from "../lincoln-theme";
import { LINCOLN_BRAND } from "../components/accessories/Brands";

/**
 * Gets the appropriate theme based on the user's brand
 * @param {string} brand - User's brand ("F" for Ford, "L" for Lincoln)
 * @returns {object} The theme object for the specified brand
 */
const getThemeByBrand = (brand) => {
  if (brand === LINCOLN_BRAND) {
    return LincolnTheme;
  }
  return F1Theme;
};

export { getThemeByBrand };
